import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageTemplate } from '@_widgets/common';
import { InputContainer } from '@_widgets/user';

import { userApi, USER_CONSTANTS } from '@_entities/user';

import { useHTMLParse } from '@_shared/hooks';
import { LeftChevronIcon } from '@_shared/icons';
import { Typography } from '@_shared/ui/Typography';

import * as S from './NicknamePage.style';

export function NicknamePage() {
	const navigate = useNavigate();
	const {
		state: { nickname },
	} = useLocation();

	const [inputNickname, setNickname] = useState<string>(nickname);
	const [message, setMessage] = useState<string>();

	const parsedMessage = useHTMLParse(message ?? '');

	return (
		<PageTemplate
			header={
				<S.Header>
					<S.BackIconWrapper
						onClick={() => {
							navigate(-1);
						}}
					>
						<LeftChevronIcon />
					</S.BackIconWrapper>
					<Typography type="title-large" color="font-primary">
						닉네임 변경
					</Typography>
					<S.ConfirmButton
						onClick={() => {
							if (nickname !== inputNickname) {
								userApi
									.updateNickname(inputNickname)
									.then(() => {
										navigate(-1);
									})
									.catch(({ response: { data } }) => {
										setMessage(data.message);
									});
							}
						}}
					>
						<Typography
							type="title-large"
							color={nickname !== inputNickname ? 'font-primary' : 'font-tertiary'}
						>
							완료
						</Typography>
					</S.ConfirmButton>
				</S.Header>
			}
			nav={false}
		>
			<S.Container>
				<InputContainer.Container>
					<InputContainer.Input
						type="text"
						defaultValue={nickname}
						maxLength={USER_CONSTANTS.NICKNAME_MAX_LENGTH}
						minLength={USER_CONSTANTS.NICKNAME_MIN_LENGTH}
						onInput={(e) => {
							const spaceRegex = /\s/;
							if (spaceRegex.exec(e.currentTarget.value)) {
								e.currentTarget.focus();
								e.currentTarget.value = e.currentTarget.value.replace(/\s| /gi, '');
							}

							setNickname(e.currentTarget.value);
						}}
					>
						<S.InputLength>
							<Typography type="label-medium" color="warmgray-400">
								{inputNickname.length}/{USER_CONSTANTS.NICKNAME_MAX_LENGTH}
							</Typography>
						</S.InputLength>
					</InputContainer.Input>

					<InputContainer.Explain>
						{message === undefined ? (
							<S.Text>
								<Typography type="label-medium" color="font-tertiary">
									한글, 영문 대소문자, 숫자, 특수문자 밑줄(_), 마침표(.)를
									포함하여 2~15자를 지원합니다.
								</Typography>
							</S.Text>
						) : (
							<Typography type="label-medium" color="orange-primary">
								{parsedMessage}
							</Typography>
						)}
					</InputContainer.Explain>
				</InputContainer.Container>
			</S.Container>
		</PageTemplate>
	);
}
